import Request from '../Request.utils'
export interface IBroadcastNotificationRequestBody {
  channels: {
    email?: boolean;
    push?: boolean;
    whatsapp?: boolean;
  };
  message: string;
  recipientFilter?: {
    roles?: ('admin' | 'user' | 'reseller' | 'customer-admin' | 'area-manager' | 'site-level' | 'global-admin')[];
    siteIds?: string[];
    userIds?: string[];
  };
  recipientType: 'all' | 'role' | 'site' | 'custom';
  scheduledAt?: string;
  status?: 'send' | 'draft' | 'schedule';
  title: string;
}
export interface IListBroadcastHistoryRequestQuery {
  page?: number;
  pageSize?: number;
  status?: 'sent' | 'scheduled' | 'draft' | 'cancelled';
}
export interface IUpdateBroadcastRequestBody {
  channels?: {
    email?: boolean;
    push?: boolean;
    whatsapp?: boolean;
  };
  message?: string;
  recipientFilter?: {
    roles?: ('admin' | 'user' | 'reseller' | 'customer-admin' | 'area-manager' | 'site-level' | 'global-admin')[];
    siteIds?: string[];
    userIds?: string[];
  };
  recipientType?: 'all' | 'role' | 'site' | 'custom';
  scheduledAt?: string;
  status?: 'draft' | 'scheduled';
  title?: string;
}
export interface IUpdateBroadcastRequestParams {
  id: string;
}
export interface ICancelBroadcastRequestParams {
  id: string;
}
export interface ISendBroadcastNowRequestParams {
  id: string;
}
export interface IListSitesRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface ISearchUsersRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}


class AdminNotificationsAPI {
  broadcastNotification = async (body: IBroadcastNotificationRequestBody) => {
    const res = await Request.call('/api/admin/notifications/broadcast', 'POST', undefined, undefined, body, );
    return res;
  }
  listBroadcastHistory = async (query: IListBroadcastHistoryRequestQuery) => {
    const res = await Request.call('/api/admin/notifications/history', 'GET', undefined, query, undefined, );
    return res;
  }
  broadcastStats = async () => {
    const res = await Request.call('/api/admin/notifications/stats', 'GET', undefined, undefined, undefined, );
    return res;
  }
  updateBroadcast = async (params: IUpdateBroadcastRequestParams, body: IUpdateBroadcastRequestBody) => {
    const res = await Request.call('/api/admin/notifications/broadcast/:id', 'PUT', params, undefined, body, );
    return res;
  }
  cancelBroadcast = async (params: ICancelBroadcastRequestParams) => {
    const res = await Request.call('/api/admin/notifications/broadcast/:id/cancel', 'POST', params, undefined, undefined, );
    return res;
  }
  sendBroadcastNow = async (params: ISendBroadcastNowRequestParams) => {
    const res = await Request.call('/api/admin/notifications/broadcast/:id/send', 'POST', params, undefined, undefined, );
    return res;
  }
  listSites = async (query: IListSitesRequestQuery) => {
    const res = await Request.call('/api/admin/notifications/sites', 'GET', undefined, query, undefined, );
    return res;
  }
  searchUsers = async (query: ISearchUsersRequestQuery) => {
    const res = await Request.call('/api/admin/notifications/users/search', 'GET', undefined, query, undefined, );
    return res;
  }
}
export default new AdminNotificationsAPI()